<template>
  <v-dialog v-model="show" class="modal" persistent max-width="739px" scrollable>
    <v-card
      style="align-items: baseline; overflow-y: auto; padding: 32px 32px; gap: 2.5rem"
      :class="[{ 'sport-organization-modal-container': isSportOrganization() }]"
    >
      <sign-in-modal-form
        v-if="!response"
        :organization-type="organizationType"
        @submit="submitForm($event)"
        @close="$emit('close')"
        @openLoginModal="handleOpenLoginModal"
      />
      <sign-in-response
        v-else
        :response="response"
        :show-forgot-password="
          isSportOrganization() &&
            response.title === 'Izgleda da je već kreiran korisnički račun povezan s ovim e-mailom.'
        "
        @next="handleNextAction"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { signUp } from '@/http'
import SignInModalForm from './SignInForm.vue'
import SignInResponse from '@/components/accreditations/organization-store/user/modals/sign-in/SignInResponse.vue'
import { OrganizationType } from '@/types'

export default {
  name: 'sign-in-dialog',
  components: { SignInModalForm, SignInResponse },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    organizationType: String,
  },
  data() {
    return {
      form: {},
      snackbar: {},
      response: null,
    }
  },

  methods: {
    handleNextAction() {
      this.response.next()

      return (this.response = null)
    },
    clearError() {
      return (this.error = null)
    },
    handleOpenLoginModal() {
      return this.$emit('openLoginModal')
    },
    async submitForm(userInfo) {
      const { errors } = await signUp(userInfo)

      if (errors) {
        const [e] = errors
        const { error, statusCode } = e
        this.password = null

        return (this.response = {
          alt: statusCode
            ? statusCode === 400 && 'Dogodila se pogreška.'
            : 'Korisnis postoji s ovim e-mailom.',
          next: statusCode
            ? statusCode === 400 &&
              function () {
                return this.clearError()
              }.bind(this)
            : function () {
              return this.handleOpenLoginModal()
            }.bind(this),
          title: statusCode
            ? statusCode === 400 && 'Uuups. Dogodila se pogreška.'
            : 'Izgleda da je već kreiran korisnički račun povezan s ovim e-mailom.',
          description: statusCode
            ? statusCode === 400 && error.message
            : 'Korisnički račun s navedenom email adresom već postoji. Prijavite se ili upišite drugu email adresu.',
          buttonLabel: statusCode ? statusCode === 400 && 'U redu' : 'Prijavi se',
          img: statusCode
            ? statusCode === 400 && '/assets/warning.png'
            : '/assets/existing-user-warning.png',
        })
      } else {
        return (this.response = {
          alt: 'Verificiraj e-mail adresu.',
          next: function () {
            return this.handleOpenLoginModal()
          }.bind(this),
          title: 'Potvrdi svoj račun',
          description:
            'Uskoro ćeš zaprimiti email za verifikaciju registracije, provjeri svoj e-mail.',
          buttonLabel: 'nastavi',
          img: '/assets/verify-email.png',
        })
      }
    },
    isSportOrganization() {
      return this.organizationType === OrganizationType.SPORT_ORGANIZATION
    },
  },
}
</script>
<style scoped>
.sport-organization-modal-container {
  background-color: #0054a5;
}
</style>
